import { AuthGuard } from '../../../shared/services';
import { UserListComponent } from './user-list.component';
import { Route } from '@angular/router';

export const UserListRoutes: Route[] = [
  {
    path: 'list/:type',
    component: UserListComponent,
    canActivate: [AuthGuard]
  }
];
